// Vendor
import { computed, ref } from 'vue';
import { defineStore } from 'pinia';
import { useLogger } from '@netvlies/utility-collection';
// Constants
import { BUNDLE_NAME } from '../index';
const useNavigation = defineStore('nav', () => {
    // Composable
    const { warn } = useLogger(BUNDLE_NAME);
    // Refs
    const registered = ref({});
    // Computed
    const itemsByLocationCode = computed(() => (code) => code in registered.value ? registered.value[code] || [] : []);
    // Methods
    function addByName(name, payload, createIfNotExists = false) {
        var _a;
        const items = Array.isArray(payload) ? payload : [payload];
        if (name in registered.value) {
            registered.value[name] = [...((_a = registered.value[name]) !== null && _a !== void 0 ? _a : []), ...items];
        }
        else {
            createIfNotExists
                ? register(name, items)
                : warn('Cannot add items to non-existing navigation');
        }
    }
    function deregister(name) {
        if (name in registered.value) {
            delete registered.value[name];
        }
    }
    function register(name, items) {
        registered.value[name] = items;
    }
    function flushAll() {
        registered.value = {};
    }
    function flushByName(name) {
        if (name in registered.value) {
            registered.value[name] = null;
        }
    }
    return {
        addByName,
        deregister,
        flushAll,
        flushByName,
        registered,
        itemsByLocationCode,
        register,
    };
});
export * from './types/index';
export { useNavigation };
//# sourceMappingURL=module.js.map